import { connect } from 'react-redux';
import React from 'react';
import NewIcon from '@mui/icons-material/LibraryAddRounded';
import { Tooltip, IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';

const styles = (theme) => ({});

class CreateNewVideoButton extends React.Component {

    render() {
        const { videoDirty, audioDirty } = this.props;

        return (
            <Tooltip
                title={videoDirty || audioDirty ? 'Create New Video (save or discard changes to enable)' : 'Create New Video'}
                arrow
                placement='bottom'
            >
                <div>
                    <IconButton
                        disabled={videoDirty || audioDirty}
                        onClick={this.onCreateNewVideoClick}
                        aria-label='Create New Video'
                        size="large">
                        <NewIcon />
                    </IconButton>
                </div>
            </Tooltip>
        );
    }

    onCreateNewVideoClick = () => {
        const { navigate, getVideoSettings, savingInProgress, showCriticalOperationProgressWarning, setProperty } = this.props;
        
        if (savingInProgress) {
            showCriticalOperationProgressWarning();
            return;
        }

        navigate('/create', { replace: true });
        setProperty('presetDialogOpen', true);
        getVideoSettings();
    }
}

const mapStateToProps = (state) => {
    const { videoDirty, audioDirty } = state.create;
    const { savingInProgress } = state.create.videoSavingState;
    return { videoDirty, audioDirty, savingInProgress }
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    const getVideoSettings = (videoId) => dispatch(createActions.getVideoSettings(videoId));
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return {
        setProperty, 
        getVideoSettings, 
        showCriticalOperationProgressWarning 
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CreateNewVideoButton, styles));